export const user_status = {
  ACTIVE: "ACTIVE",
  SUSPENDED: "SUSPENDED",
};
export const user_role = {
  ADMIN: "ADMIN",
  ACCOUNTANT: "ACCOUNTANT",
  STAFF: "STAFF",
  PRIMARY_CLIENT: "PRIMARY_CLIENT"
};
export const query_type = {
  NORMAL: "NORMAL",
  TRANSACTIONAL: "TRANSACTIONAL",
  REVIEW_POINTS: "REVIEW_POINTS",
};
export const entity_type = {
  SMSF: "SMSF",
  Individual: "Individual",
  Company: "Company",
  Trust: "Trust",
  Partnership: "Partnership"
};
export const fy_status = {
  OPEN: "OPEN",
  QUERIES_PENDING: "QUERIES PENDING",
  QUERIES_RESOLVED: "QUERIES RESOLVED",
  CLOSED: "CLOSED",
};
export const priority_order = [
  "NORMAL",
  "HIGH",
  "HIGHEST",
  "URGENT",
  "MOST URGENT",
];
export const fy_status_order = [
  "OPEN",
  "QUERIES PENDING",
  "QUERIES RESOLVED",
  "CLOSED",
];

export const periodTypes = ['Yearly', 'Quarterly', 'Ad-Hoc'];
export const financialYearTypes = ['SMSF', 'ITR', 'CTR', 'TTR', 'PTR', 'Bookkeeping', 'Other'];
export const entityTypes = ['SMSF', 'Individual', 'Company', 'Trust', 'Partnership', 'Other'];
export const paths = ['firms', 'manage_users', 'users', 'invite', 'help-center',
  'auth', 'termsandcondition', 'privacy', ''];
